import React, { lazy, Suspense, useEffect, useState } from 'react';
import { MetaPixel } from './components/MetaPixel';
import { StickyHeader } from './components/StickyHeader';
import { Hero } from './components/Hero';
import { StartRoutes } from './components/StartRoutes';
const DeferredLanding = lazy(() => import('./components/DeferredLanding').then(({
  DeferredLanding: Component
}) => ({
  default: Component
})));
export function App() {
  const [loadDeferredContent, setLoadDeferredContent] = useState(false);
  useEffect(() => {
    const timer = window.setTimeout(() => setLoadDeferredContent(true), 900);
    return () => window.clearTimeout(timer);
  }, []);
  return <div className="w-full bg-cream text-plum" data-id="element-0" data-mp="31ctdnmtavs6j">
      <MetaPixel data-id="element-1" data-mp="2wjqhd6x524mn" />
      <StickyHeader data-id="element-2" data-mp="2wj8dpp85co4p" />
      <main data-id="element-3" data-mp="2wip7h5ruzo6i">
        <span id="hero-sentinel" aria-hidden="true" data-id="element-4" data-mp="2wi5n7ieqknpb" />
        <Hero data-id="element-5" data-mp="28te2fc3h77mk" />
        <StartRoutes data-id="element-6" data-mp="28sutulzptvl7" />
        {loadDeferredContent && <Suspense fallback={<div className="h-10 bg-cream" aria-hidden="true" data-id="element-8" data-mp="23w4fq47h1a2f" />} data-id="element-7" data-mp="23vkwmk634fmt">
            <DeferredLanding data-id="element-9" data-mp="23ti67z10skhk" />
          </Suspense>}
      </main>
    </div>;
}